import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AIModelProvider = 'gemini' | 'azure';

export interface AISettings {
  modelProvider: AIModelProvider;
}

const STORAGE_KEY = 'rimini_ai_settings';

@Injectable({ providedIn: 'root' })
export class AiSettingsService {
  private defaultSettings: AISettings = {
    modelProvider: 'azure'
  };

  private settingsSubject = new BehaviorSubject<AISettings>(this.loadSettings());

  settings$ = this.settingsSubject.asObservable();

  get currentSettings(): AISettings {
    return this.settingsSubject.value;
  }

  get modelProvider(): AIModelProvider {
    return this.settingsSubject.value.modelProvider;
  }

  private loadSettings(): AISettings {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return { ...this.defaultSettings, ...JSON.parse(stored) };
      }
    } catch (e) {
      console.warn('Failed to load AI settings from localStorage:', e);
    }
    return this.defaultSettings;
  }

  saveSettings(settings: Partial<AISettings>): void {
    const newSettings = { ...this.settingsSubject.value, ...settings };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newSettings));
    } catch (e) {
      console.warn('Failed to save AI settings to localStorage:', e);
    }
    this.settingsSubject.next(newSettings);
  }

  setModelProvider(provider: AIModelProvider): void {
    this.saveSettings({ modelProvider: provider });
  }
}
